import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { ClassifyFormWrapperComponent } from '../form-wrapper/form-wrapper.component';
import { 
  CategoryFormConfig,
  CATEGORY_HEADER_ACTIONS,
  CATEGORY_PROPERTY_TABLE_SECTION,
  getCategoryFormFields
} from '../../models/classify.config';
import { TextNormalizerService } from '@shared/services/text-normalizer.service';

@Component({
  selector: 'app-classify-edit',
  standalone: true,
  imports: [ClassifyFormWrapperComponent],
  templateUrl: './classify-edit.component.html',
  styleUrls: ['./classify-edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassifyEditComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: ClassifyFormWrapperComponent;

  private textNormalizer = inject(TextNormalizerService);
  
  config: CategoryFormConfig = {
    title: 'goods.classify.form.edit.title',
    formFields: getCategoryFormFields(this.textNormalizer),
    tableSections: [CATEGORY_PROPERTY_TABLE_SECTION],
    headerActions: CATEGORY_HEADER_ACTIONS,
    listRoute: '/goods/classify',
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
